/*@ngInject*/
const MultiSelectConfirmationModalController = function ($window, $rootScope, $state, $scope, options, coreConstant) {

    $scope.viewModel = {
        successCount: options.successCount,
        totalRequested: options.totalRequested,
        errorList: options.errorList
    };

    $scope.onOpenErrorSubmission = function (submissionId) {
        var url = $state.href('submission', { submissionId: submissionId});
        $window.open(url,'_blank');
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('multiSelectConfirmationModalController', MultiSelectConfirmationModalController);
